import { ITransition } from "./Models";
import { IModalWorkflowApi } from "./ModalWorkflow";
import { ILoadedConfig } from "./HtmlWorkflowDialog";

interface ITransitionDescription {
	name: string;
	friendlyName: string;
	fromStateId: string;
	toStateId: string;
	color: string;
}

interface ISuccess {
	successMessage: string;
	redirect: string;
	openInNewTabs: string[],
}

(function (qdesk, $) {
	(function (workflow) {
		
		class AjaxWorkflow {
			
			runUrl(url: string) {
				(qdesk.workflow.modalWorkflow as IModalWorkflowApi).runUrl(url);
			}

			runTransition(transition: ITransition) {
				(qdesk.workflow.modalWorkflow as IModalWorkflowApi).runTransition(transition);
			}

			isOpen(): boolean {
				return qdesk.htmlWorkflowDialog.isOpen();
			}
			
			error(errors: string | Array<string>) {
				qdesk.htmlWorkflowDialog.setErrors(errors);
			}

			redirect(data: ISuccess) {

				if (data.openInNewTabs) {
					for (var i = 0; i < data.openInNewTabs.length; i++) {
						let w = window.open(data.openInNewTabs[i], "_blank");
					}
				}
				
				qdesk.htmlWorkflowDialog.setRedirect(data);
				window.location.href = data.redirect;
			}

			loaded(config: ILoadedConfig) {
				qdesk.htmlWorkflowDialog.setConfig(config);
			}

			setContinue(url: string) {
				qdesk.htmlWorkflowDialog.setContinueUrl(url);
			}

			getContinue() {
				return qdesk.htmlWorkflowDialog.getContinueUrl();
			}

			setIsTransient(value: boolean) {
				qdesk.htmlWorkflowDialog.setIsTransient(value);
			}
		}

		workflow.ajax = new AjaxWorkflow();
	}(qdesk.workflow = qdesk.workflow || {}));
}((<any>window).qdesk = (<any>window).qdesk || {}, (<any>window).$));